"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// import Button from './../Business/Button';

var SEMContact = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var title = props.title,
    titleColor = props.titleColor,
    subhead = props.subhead,
    content = props.content,
    contentColor = props.contentColor,
    pcBackgroundImage = props.pcBackgroundImage,
    mbBackgroundImage = props.mbBackgroundImage,
    _a = props.buttonConfig,
    buttonConfig = _a === void 0 ? [] : _a;
  var pcBackgroundImageUrl = (0, _utils.fomateFileData)(pcBackgroundImage).url;
  var mbBackgroundImageUrl = (0, _utils.fomateFileData)(mbBackgroundImage).url;
  var _b = (0, _react.useState)(''),
    pcBgUrl = _b[0],
    setPcBgUrl = _b[1];
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (status) {
        setPcBgUrl(pcBackgroundImageUrl);
      } else {
        setPcBgUrl(mbBackgroundImageUrl);
      }
    }, 1);
  }, [pcBgUrl, pcBackgroundImage, mbBackgroundImage]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: 'SME_flex-contact-default'
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-contact-default-container',
    style: pcBgUrl ? {
      background: "url(" + pcBgUrl + ")  no-repeat center center",
      backgroundSize: '100% 100%'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-container-include'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-container-left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-title',
    style: titleColor ? {
      color: titleColor
    } : {}
  }, title, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'sme-subhead'
  }, subhead)), /*#__PURE__*/_react["default"].createElement("p", {
    style: contentColor ? {
      color: contentColor
    } : {}
  }, content)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-contact-default-container-right', {
      'flex-contact-default-container-right--expand': (0, _typeof2["default"])(buttonConfig) === 'object',
      'flex-contact-default-container-right--array': !Array.isArray(buttonConfig)
    })
  }, buttonConfig.map(function (item, index) {
    var _a = item || {},
      onCallback = _a.onCallback,
      _b = _a.extendProps,
      extendProps = _b === void 0 ? {} : _b,
      disabled = _a.disabled,
      backgroundColor = _a.backgroundColor,
      txtColor = _a.txtColor;
    /*  if (href) {
      return (
        <a
          href={href}
          rel="noreferrer"
          key={index}
          {...extendProps}
          className={classNames('sme-but', {
            'sme-but-ghost': [0].includes(index) && !disabled,
            'sme-but-colours': [1].includes(index) && !disabled,
            'sme-but-disabled': disabled,
          })}
        >
          {item.txt}
        </a>
      );
    }*/
    return /*#__PURE__*/_react["default"].createElement("button", __assign({
      onClick: function onClick() {
        !disabled && (onCallback === null || onCallback === void 0 ? void 0 : onCallback(item));
      }
    }, extendProps, {
      key: index,
      className: (0, _classnames["default"])('sme-but', {
        'sme-but-ghost': [0].includes(index) && !disabled,
        'sme-but-ghost-hover': [0].includes(index) && !disabled && !backgroundColor,
        'sme-but-colours': [1].includes(index) && !disabled,
        'sme-but-colours-hover': [1].includes(index) && !disabled && !backgroundColor,
        'sme-but-disabled': disabled,
        'sme-but-disabled-hover': disabled && !backgroundColor,
        'sme-except-other': backgroundColor
      }),
      style: backgroundColor ? {
        background: backgroundColor,
        color: txtColor
      } : {}
    }), item.txt);
  })))));
});
SEMContact.displayName = 'TCIContact';
var _default = exports["default"] = SEMContact;